import {CompositeAccessRule, defineAccessControlledResource, GroupAccessRule} from '@igp/shared/access-control';

import {DebtResponsibleMasterAgentAccessRule, groups} from '@access-control';

export const debtTransferLogsPageResource = defineAccessControlledResource({
    name: 'DebtTransferLogsPageResource',
    rules: new CompositeAccessRule([new GroupAccessRule([groups.adminsGroup]), new DebtResponsibleMasterAgentAccessRule()], 'or'),
});
